import {Component, ElementRef, forwardRef, Host, HostListener, Injector, Input, OnInit, Optional, Renderer2, SkipSelf, ViewChild} from '@angular/core';
import {ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DateConverterService} from '../../../converters/date-converter.service';
import {ValueAccessorAbstract} from '@wba-ui-module/components/formfields/commons/value-accessor.abstract';
import {EventUtils} from '@wba/utils/event.utils';
import {FormUtils} from '@wba/utils/form.utils';

@Component({
    selector: 'wba-input-datepicker',
    templateUrl: './datepicker.component.html',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatepickerComponent),
            multi: true
        }],
    standalone: false
})
export class DatepickerComponent extends ValueAccessorAbstract implements ControlValueAccessor, OnInit {

  @Input() id: string;
  @Input() name: string;
  @Input() title = '';
  @Input() label: string;
  @Input() placeholder = 'TT.MM.JJJJ';
  @Input() ariaLabel: string;
  @Input() inputType = 'text';
  @Input() required: boolean;
  @Input() hinweis: { target: string, modal: string };
  @Input() errorLabel: string;

  @ViewChild('input') el: ElementRef;
  // The internal data model

  constructor(@Optional() @Host() @SkipSelf() private readonly controlContainer: ControlContainer,
              private readonly eventUtils: EventUtils,
              private readonly elementRef: ElementRef,
              private readonly renderer: Renderer2,
              protected injector: Injector) {
  super(injector);
}

  @HostListener('input', ['$event'])
  onKeyDown(event) {
    const initalValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initalValue.replaceAll(/[^\d.]/g, '');
    if (initalValue !== this.el.nativeElement.value) {
      event.stopPropagation();
      this.value = this.el.nativeElement.value;
    }
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName) as FormControl;
      }
    }
  }

  // Set touched on blur
  onBlur() {
    if (this.value?.length > 0) {
      this.writeValue(FormUtils.formValueSingleWhitespaces(this.value));
    }

    this.value = DateConverterService.convert(this.value);
    this.el.nativeElement.value = this.value;
    this.onChangeCallback(this.value);
    this.onTouchedCallback();

    this.eventUtils.focusOut$.next(this.elementRef);
  }
}
